import { AdminTemplate } from "../../components";
import { GMUSoftPosControl } from "../../components/organisms";

export const GMUSoftPosControlPage = () => {

    return (
        <AdminTemplate
            headerProps={{
                headerTitle: "GMU & SoftPos",
                hideAddButton: true
            }}
        >
            <GMUSoftPosControl />
        </AdminTemplate>
    );
};
